import StudentRegistrationTypeColumns from '@data/StudentRegistrationTypeColumns'
import TeacherRegistrationTypeColumns from '@data/TeacherRegistrationTypeColumns'
import RevisorRegistrationTypeColumns from '@data/RevisorRegistrationTypeColumns'
import ManagerRegistrationTypeColumns from '@data/ManagerRegistrationTypeColumns'
import RegistrationTypeColumn from '@interfaces/IRegistrationTypeColumn'
import RoleEnum from '@enums/Role.enum'
import IRegistrationEntity from '@interfaces/IRegistrationEntity'

class RegistrationTypeAction {
  private role: RoleEnum

  public constructor(role: RoleEnum) {
    this.role = role
  }

  public getColumns() : RegistrationTypeColumn[] {
    switch (this.role) {
    case RoleEnum.Student:
      return StudentRegistrationTypeColumns.filter(c => c.display !== false)

    case RoleEnum.Teacher:
      return TeacherRegistrationTypeColumns.filter(c => c.display !== false)

    case RoleEnum.Revisor:
      return RevisorRegistrationTypeColumns.filter(c => c.display !== false)

    case RoleEnum.Manager:
      return ManagerRegistrationTypeColumns.filter(c => c.display !== false)

    default:
      return [] as RegistrationTypeColumn[]
    }
  }

  public getLabels() : string[] {
    return this.getColumns().map(column => column.label)
  }

  public getEntities(rows: string[][], additionalData: any) : IRegistrationEntity[] {
    const entities: IRegistrationEntity[] = []

    const columns = this.getColumns()

    rows.forEach((row: string[], index: number) => {
      if (!this.isRowEmpty(row)) {
        const entity: any = {
          index,
        }

        columns.forEach((column: RegistrationTypeColumn, index: number) => {
          const value = row[index] ?? null
          entity[column.key] = column.worker?.(value) ?? value
        })

        entities.push({
          ...entity,
          ...additionalData,
        } as IRegistrationEntity)
      }
    })

    return entities
  }

  public isValid(header: string[]) : boolean {
    const labels = this.getLabels()
    return header.every((label: string, index: number) => label === labels[index])
  }

  public isRowEmpty(row: string[]) : boolean {
    return row.every((value: string) => !value)
  }
}

export default RegistrationTypeAction
